import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FaArrowLeftLong,
  FaRegHospital,
  FaMapLocationDot,
  FaScrewdriverWrench,
} from "react-icons/fa6";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Lottie from "lottie-react";
// Small helper import
import { IconButton, Stack } from "@mui/material";

import {
  Box,
  TextField,
  Button,
  Typography,
  Card,
  CardContent,
  Grid,
  Avatar,
  Stepper,
  Step,
  StepLabel,
  Divider,
  Container,
  Paper,
} from "@mui/material";

// Animation Imports (Keep your local paths)
import successAnim from "./Trophy.json";
import databaseAnim from "./database.json";
import errorAnim from "./Errorfailure.json";
import loadingAnim from "./SandyLoading.json";

const base_url = "https://application.eterp.in/";
const steps = ["Fill Details", "Server Sync", "Database Integration"];

export const Register = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [registerData, setRegisterData] = useState({});
  const [logo, setLogo] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [status, setStatus] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [successData, setSuccessData] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRegisterData({ ...registerData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setSelectedImage(reader.result);
      reader.readAsDataURL(file);
      setLogo(file);
    }
  };

  const handleRegister = async () => {
    if (!registerData.company_name || !registerData.email) {
      return toast.error("Please fill in basic company details.");
    }
    setActiveStep(1);
    setStatus("loading");

    const formData = new FormData();
    Object.entries(registerData).forEach(([key, value]) =>
      formData.append(key, value)
    );
    if (logo) formData.append("logo", logo);

    try {
      const res = await axios.post(`${base_url}company/master`, formData);
      if (res?.data?.success) {
        setSuccessMessage(res?.data?.message);
        setStatus("success");
        setSuccessData(res?.data?.data);
      } else {
        throw new Error(res?.data?.message || "Registration Failed");
      }
    } catch (err) {
      setStatus("fail");
      setErrorMessage(
        err.response?.data?.message || err.message || "Connection Error"
      );
    }
  };

  const runCheckandUpdates = (key) => {
    setActiveStep(2);
    setStatus("syncing");
    axios
      .post(`${base_url}checkandupdate`, {
        config: key,
        migrationMode: "upfront",
      })
      .then(() => {
        setStatus("success");
        setSuccessMessage("Database Integration Successful!");
      })
      .catch(() => {
        setStatus("fail");
        setErrorMessage("Database Sync Failed!");
      });
  };

  return (
    <Box
      sx={{
        // minHeight: "100vh",
        background: "linear-gradient(135deg, #f8fafd 0%, #e2eaf4 100%)",
        py: 4,
      }}
    >
      <Container maxWidth="lg">
        <ToastContainer />

        {/* Header Section */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 4,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {status === "idle" && (
              <IconButton
                onClick={() => navigate(-1)}
                sx={{ bgcolor: "white", boxShadow: 1 }}
              >
                <FaArrowLeftLong size={20} color="#1a237e" />
              </IconButton>
            )}
            <Typography
              variant="h4"
              sx={{
                fontWeight: 900,
                color: "#1a237e",
                fontSize: { xs: "1.5rem", md: "2rem" },
              }}
            >
              Company <span style={{ color: "#2db7e8" }}>Setup</span>
            </Typography>
          </Box>

          <Stepper
            activeStep={activeStep}
            sx={{ width: "40%", display: { xs: "none", md: "flex" } }}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        <Card
          sx={{
            borderRadius: 5,
            boxShadow: "0 20px 60px rgba(26, 35, 126, 0.08)",
            border: "1px solid rgba(255,255,255,0.8)",
            bgcolor: "rgba(255, 255, 255, 0.95)",
          }}
        >
          <CardContent sx={{ p: status === "idle" ? 4 : 8 }}>
            {status === "idle" ? (
              <Grid container spacing={4}>
                {/* 1. Left Sidebar: Logo & Identity */}
                <Grid item xs={12} md={3.5}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      textAlign: "center",
                      borderRadius: 4,
                      bgcolor: "#fcfdfe",
                      height: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        width: 120,
                        height: 120,
                        borderRadius: "50%",
                        border: "3px solid #2db7e8",
                        mx: "auto",
                        p: 0.5,
                        mb: 2,
                        position: "relative",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                    >
                      <Avatar
                        src={selectedImage}
                        sx={{
                          width: "100%",
                          height: "100%",
                          bgcolor: "#e3f2fd",
                          color: "#2db7e8",
                          fontSize: 12,
                        }}
                      >
                        LOGO
                      </Avatar>
                      <input
                        type="file"
                        id="fileInput"
                        hidden
                        accept="image/*"
                        onChange={handleFileChange}
                      />
                    </Box>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 700, mb: 3 }}
                    >
                      Brand Identity
                    </Typography>
                    <Stack spacing={2}>
                      <TextField
                        fullWidth
                        label="Company Name"
                        name="company_name"
                        size="small"
                        onChange={handleChange}
                      />
                      <TextField
                        fullWidth
                        label="Short Name"
                        name="short_name"
                        size="small"
                        onChange={handleChange}
                      />
                    </Stack>
                  </Paper>
                </Grid>

                {/* 2. Middle & Right: Details */}
                <Grid item xs={12} md={8.5}>
                  <Grid container spacing={3}>
                    {/* Basic Info */}
                    <Grid item xs={12}>
                      <SectionHeader
                        icon={<FaRegHospital />}
                        title="Contact Information"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Mobile Number"
                        name="mobile_no"
                        size="small"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Email Address"
                        name="email"
                        size="small"
                        onChange={handleChange}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Web Address"
                        name="web_address"
                        size="small"
                        onChange={handleChange}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Alternative Mobile Number"
                        name="phone_no"
                        size="small"
                        onChange={handleChange}
                      />
                    </Grid>


                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Notes"
                        name="notes"
                        size="small"
                        multiline
                        rows={2}
                        onChange={handleChange}
                      />
                    </Grid>

                    {/* Legal & Location */}
                    <Grid item xs={12}>
                      <SectionHeader
                        icon={<FaMapLocationDot />}
                        title="Location & Legal"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="GST Number"
                        name="gst_no"
                        size="small"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="PIN Code"
                        name="pin_code"
                        size="small"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Full Address"
                        name="address"
                        multiline
                        rows={2}
                        size="small"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="City"
                        name="city"
                        size="small"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="State"
                        name="state"
                        size="small"
                        onChange={handleChange}
                      />
                    </Grid>

                    {/* System Config */}
                    <Grid item xs={12}>
                      <SectionHeader
                        icon={<FaScrewdriverWrench />}
                        title="System Configuration"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        label="Devices"
                        name="no_of_devices"
                        type="number"
                        size="small"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        label="Watermark"
                        name="watermark_text"
                        size="small"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <DatePicker
                        label="Subscription Expiry"
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: { fullWidth: true, size: "small" },
                        }}
                        onChange={(date) =>
                          setRegisterData({
                            ...registerData,
                            renewable_date: dayjs(date).format("DD/MM/YYYY"),
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Action Button */}
                <Grid item xs={12} sx={{ textAlign: "right", mt: 2 }}>
                  <Divider sx={{ mb: 3 }} />
                  <Button
                    variant="contained"
                    onClick={handleRegister}
                    sx={{
                      px: 6,
                      py: 1.5,
                      borderRadius: 2,
                      fontWeight: 700,
                      background:
                        "linear-gradient(45deg, #1a237e 30%, #2db7e8 90%)",
                      boxShadow: "0 10px 20px rgba(26, 35, 126, 0.2)",
                      "&:hover": {
                        transform: "scale(1.02)",
                        transition: "0.2s",
                      },
                    }}
                  >
                    Complete Registration
                  </Button>
                </Grid>
              </Grid>
            ) : (
              <StatusView
                status={status}
                activeStep={activeStep}
                successMessage={successMessage}
                errorMessage={errorMessage}
                successData={successData}
                navigate={navigate}
                runCheckandUpdates={runCheckandUpdates}
                setActiveStep={setActiveStep}
                setStatus={setStatus}
              />
            )}
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

// --- Sub-Components for Cleanliness ---

const SectionHeader = ({ icon, title }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
    <Box sx={{ color: "#2db7e8", display: "flex" }}>{icon}</Box>
    <Typography
      variant="overline"
      sx={{ fontWeight: 800, color: "#1a237e", letterSpacing: 1.2 }}
    >
      {title}
    </Typography>
    <Divider sx={{ flexGrow: 1, ml: 1, opacity: 0.6 }} />
  </Box>
);

const StatusView = ({
  status,
  activeStep,
  successMessage,
  errorMessage,
  successData,
  navigate,
  runCheckandUpdates,
  setActiveStep,
  setStatus,
}) => {
  const configs = {
    loading: {
      anim: loadingAnim,
      title: "Processing...",
      text: "We are validating your details.",
      color: "#1a237e",
    },
    syncing: {
      anim: databaseAnim,
      title: "Syncing Database",
      text: "Configuring your tables and environment.",
      color: "#2db7e8",
    },
    success: {
      anim: successAnim,
      title: "Everything looks great!",
      text: successMessage,
      color: "#4caf50",
      btn: activeStep === 1 ? "Start Database Sync" : "Go to Dashboard",
      action:
        activeStep === 1
          ? () => runCheckandUpdates(successData)
          : () => navigate("/home"),
    },
    fail: {
      anim: errorAnim,
      title: "Action Required",
      text: errorMessage,
      color: "#e65252",
      btn: activeStep === 1 ? "Go Back & Edit" : "Retry Sync",
      action:
        activeStep === 1
          ? () => {
            setActiveStep(0);
            setStatus("idle");
          }
          : () => runCheckandUpdates(successData),
    },
  };

  const current = configs[status];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Lottie animationData={current.anim} style={{ width: 280 }} />
      <Typography
        variant="h5"
        sx={{ mt: 3, fontWeight: 800, color: current.color }}
      >
        {current.title}
      </Typography>
      <Typography
        variant="body1"
        sx={{ mt: 1, color: "text.secondary", maxWidth: 450 }}
      >
        {current.text}
      </Typography>
      {current.btn && (
        <Button
          variant="contained"
          sx={{ mt: 4, px: 5, borderRadius: 2, bgcolor: current.color }}
          onClick={current.action}
        >
          {current.btn}
        </Button>
      )}
    </Box>
  );
};
